// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.height-whole-100-S3_tjJ{height:100%;overflow:visible}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"height-whole-100": `height-whole-100-S3_tjJ`,
	"heightWhole100": `height-whole-100-S3_tjJ`
};
export default ___CSS_LOADER_EXPORT___;
